var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteSvgRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666748,
    width: 48,
    height: 48,
    rx: 8,
    fill: "#F1573D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6667 33C19.1167 33 18.6459 32.8042 18.2542 32.4125C17.8626 32.0208 17.6667 31.55 17.6667 31V18H16.6667V16H21.6667V15H27.6667V16H32.6667V18H31.6667V31C31.6667 31.55 31.4709 32.0208 31.0792 32.4125C30.6876 32.8042 30.2167 33 29.6667 33H19.6667ZM29.6667 18H19.6667V31H29.6667V18ZM21.6667 29H23.6667V20H21.6667V29ZM25.6667 29H27.6667V20H25.6667V29Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteSvgRed);
export default __webpack_public_path__ + "static/media/deleteSvgRed.8d85821a579f4a1b74355212efc94cdd.svg";
export { ForwardRef as ReactComponent };